import { __assign } from "tslib";
import React from 'react';
import { SplitTreatments } from './SplitTreatments';
/**
 * High-Order Component for SplitTreatments.
 * The wrapped component receives all the props of the container,
 * along with the passed props from SplitTreatments (see ISplitTreatmentsChildProps).
 *
 * @param names list of feature flag names
 * @param attributes An object of type Attributes used to evaluate the feature flags.
 */
export function withSplitTreatments(names, attributes) {
    return function withSplitTreatmentsHoc(WrappedComponent) {
        return function wrapper(props) {
            return (React.createElement(SplitTreatments, { names: names, attributes: attributes }, function (splitProps) {
                return (React.createElement(WrappedComponent, __assign({}, props, splitProps)));
            }));
        };
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-react/es/withSplitTreatments.js
// module id = 3952
// module chunks = 25